import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import './styles.scss';

const FullDetailsAccordion = ({
  id,
  children,
  detailsComponent,
  expanded,
  selectCallback
}) => {
  return (
    <div>
      <Accordion
        square={true}
        classes={{
          root: 'accordion-item'
        }}
        expanded={expanded}
        onChange={(_, expanded) => {
          selectCallback(expanded ? id : '');
        }}
      >
        <AccordionSummary
          id={id}
          aria-controls={id}
          expandIcon={<ExpandMoreIcon className="expand-icon" />}
          classes={{
            root: 'summary-root',
            expandIconWrapper: 'expand-icon'
          }}
        >
          <div className="list-item">{children}</div>
        </AccordionSummary>

        <AccordionDetails>
          <div className="accordion-details">{detailsComponent}</div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

FullDetailsAccordion.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,
  detailsComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
    .isRequired,
  selectCallback: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired
};

export default FullDetailsAccordion;
